'use client';

import { c as _c } from "react/compiler-runtime";
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { useMapDownloadPath } from '@repo/maps/maps/utils/use-map-download-path';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectTitleId } from '@repo/store/maps/slices/mapData';
import { Link } from '@repo/ui/components/link/link';
const footerStyles = css({
  display: 'flex',
  alignItems: 'center',
  height: '[45px]',
  borderTop: '[1px solid]',
  borderColor: 'whiteAlpha.5',
  width: 'full',
  flexShrink: 0,
  backgroundColor: '[rgba(255,255,255,0.025)]'
});
const footerLinkStyles = css({
  display: 'flex',
  alignItems: 'center',
  width: 'full',
  minWidth: '0',
  height: 'full',
  paddingX: '10',
  gap: '8',
  cursor: 'pointer',
  background: 'transparent',
  border: 'none',
  textAlign: 'left',
  textDecoration: 'none',
  _hover: {
    '& [data-ad-cta-pill]': {
      color: 'text.highlight'
    }
  }
});
const ctaPillStyles = css({
  fontWeight: 'medium',
  fontSize: '[10px]',
  lineHeight: '[12px]',
  color: 'text.primary',
  border: '[1px solid]',
  borderColor: '[rgba(255,255,255,0.25)]',
  borderRadius: 'full',
  paddingX: '8',
  paddingY: '6',
  textTransform: 'uppercase',
  flexShrink: 0,
  transition: 'colors',
  transitionDuration: 'fast',
  _after: {
    content: '" →"'
  }
});
export function MapSidebarAdCta() {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const mapId = useAppSelector(selectExternalMapId);
  const titleId = useAppSelector(selectTitleId);
  let t1;
  if ($[1] !== mapId || $[2] !== titleId) {
    t1 = {
      mapId,
      titleId
    };
    $[1] = mapId;
    $[2] = titleId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const downloadPath = useMapDownloadPath("map_sidebar_ad", t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      flex: "1",
      minWidth: "0",
      lineHeight: "[16px]"
    });
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Type variant="body-s" color="text.primary" className={t2}>{t3}</Type>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp2);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <span data-ad-cta-pill={true} className={ctaPillStyles}>{t5}</span>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== downloadPath || $[14] !== t4 || $[15] !== t6) {
    t7 = <footer className={footerStyles}><Link href={downloadPath} className={footerLinkStyles}>{t4}{t6}</Link></footer>;
    $[13] = downloadPath;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp2($_0) {
  return $_0.sidebar_ad.get_wand;
}
function _temp($) {
  return $.sidebar_ad.ad_free_maps_in_app;
}